import { BULLETIN_TYPES } from '../common/store/constants/sportTypes';

//canlı maç varsa canlı tabi açılacaktır. Hem mw hem dw ortaktır.

export const getBulletinTargetPath = ({ path, bulletinTabs = [] }) => {
  if (path !== '/iddaa') return path;

  const liveTab = bulletinTabs.find(tab => tab.id === BULLETIN_TYPES.LIVE);
  return liveTab?.count ? '/canli-iddaa' : '/iddaa';
};
